import { Component, ElementRef, Input, OnInit, ViewEncapsulation } from "@angular/core";

enum TextStyle {
  Display = "display",
  TitleLarge = "title-large",
  TitleMedium = "title-medium",
  HeadlineSemibold = "headline-semibold",
  HeadlineRegular = "headline-regular",
  TextXXLargeSemibold = "text-xxlarge-semibold",
  TextLargeSemibold = "text-large-semibold",
  TextMediumSemibold = "text-medium-semibold",
  TextSmallSemibold = "text-small-semibold",
  TextXSmallSemibold = "text-xsmall-semibold",
  TextLargeRegular = "text-large-regular",
  TextMediumRegular = "text-medium-regular",
  TextSmallRegular = "text-small-regular",
  TextXSmallRegular = "text-xsmall-regular"
}

/**
 * Typography component:
 *  `<typography-legacy title-large>Title large</typography-legacy>`
 *  or
 * `<h1 title-large>Title large</h1>`
 *  or
 * `<p text-medium-semibold>Text medium semibold</p>`
 */

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: `typography-legacy, typography-legacy[display], *[display], typography-legacy[title-large],
  *[title-large], typography-legacy[title-medium], *[title-medium], typography-legacy[headline-semibold],
  *[headline-semibold], typography-legacy[headline-regular],  *[headline-regular],
  typography-legacy[text-large-semibold], p[text-large-semibold], typography-legacy[text-medium-semibold],
  p[text-medium-semibold], typography-legacy[text-small-semibold], p[text-small-semibold],
  typography-legacy[text-xxlarge-semibold], typography-legacy[text-large-regular], p[text-large-regular], typography-legacy[text-medium-regular],
  p[text-medium-regular], typography-legacy[text-small-regular], p[text-small-regular]],
  typography-legacy[text-xsmall-regular], typography-legacy[text-xsmall-semibold]`,
    templateUrl: "./typography.component.html",
    styleUrls: ["./typography.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TypographyComponentLegacy implements OnInit {
  @Input() color: string;

  constructor(public _elementRef: ElementRef) {}

  ngOnInit() {
    const hostEl = this._getHostElement() as HTMLElement;
    const hostElAttrs = hostEl.getAttributeNames();

    for (const value of this._styleKeys(TextStyle)) {
      if (hostElAttrs.includes(TextStyle[value])) {
        hostEl.classList.add(TextStyle[value]);
      }
    }

    if (this.color) {
      hostEl.style.setProperty("color", this.color);
    }
  }

  private _getHostElement() {
    return this._elementRef.nativeElement;
  }

  // private _hasHostAttributes(...attributes: string[]) {
  //   return attributes.some(attribute => this._getHostElement().hasAttribute(attribute));
  // }

  private _styleKeys<O extends object, K extends keyof O = keyof O>(obj: O): K[] {
    return Object.keys(obj).filter(k => Number.isNaN(+k)) as K[];
  }
}
